import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { HubReportsGridComponent, HubReportComponent, PageNotFoundComponent, HubReportV2Component, HubReportsV2GridComponent } from 'reg-hub-common';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoggedOutComponent } from './auth/logged-out/logged-out.component';
import { SearchOrdersComponent } from './orders/search-orders/search-orders.component';
import { OrderComponent } from './orders/order/order.component';
import { CallbackComponent } from './auth/callback/callback.component';
import { BaseOrderInformationComponent } from './orders/base-order-information/base-order-information.component';
import { MyAccountComponent } from './auth/my-account/my-account.component';
import { InformationDocumentsComponent } from './information-documents/information-documents.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { ClientGuard } from './auth-guard';
import { SystemEventsHistoryComponent } from './system-event-history/system-events-history.component';
import { PrintOrderComponent } from './orders/print-order/print-order.component';
import { PrintComponent } from './navigation/print/print.component';
import { WrapperComponent } from './navigation/wrapper/wrapper.component';
import { VinsightsComponent } from './consortium/vinsights/vinsights.component';
import { NewRegistrationComponent } from './orders/new-registration/new-registration.component';
import { NewSearchComponent } from './orders/new-search/new-search.component';
import { NewBusinessSearchComponent } from './orders/new-business-search/new-business-search.component';
import { NewLandSearchComponent } from './orders/new-land-search/new-land-search.component';
import { BaseKnowYourCustomerInformationComponent } from './orders/base-know-your-customer-information/base-know-your-customer-information.component';
import { NewKnowYourCustomerComponent } from './orders/new-know-your-customer/new-know-your-customer.component';

const routes: Routes = [
  {
    path: '', component: WrapperComponent, children: [
      { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent, title: 'routes.dashboard', canActivate: [ClientGuard] },
      { path: 'sso', title: 'routes.dashboard', canActivate: [ClientGuard], children: [
        { path: ':idp', component: DashboardComponent }
      ] },
      { path: 'orders', title: 'routes.orderHistory', canActivate: [ClientGuard], children: [
        { path: '', component: SearchOrdersComponent },
        { path: 'ppsa-registration', title: 'routes.ppsaRegistration', children: [
          { path: '', component: BaseOrderInformationComponent },
          { path: ':orderID', component: NewRegistrationComponent },
        ] },
        { path: 'ppsa-search', title: 'routes.ppsaSearch', children: [
          { path: '', component: BaseOrderInformationComponent },
          { path: ':orderID', component: NewSearchComponent }
        ] },
        { path: 'business', title: 'routes.businessSearch', children: [
          { path: '', component: BaseOrderInformationComponent },
          { path: ':orderID', component: NewBusinessSearchComponent }
        ] },
        { path: 'kyc', title: 'routes.knowYourCustomer', children: [
          { path: '', component: BaseKnowYourCustomerInformationComponent },
          { path: ':orderID', component: NewKnowYourCustomerComponent }
        ] },
        { path: 'land', title: 'routes.landSearch', children: [
          { path: '', component: BaseOrderInformationComponent },
          { path: ':orderID', component: NewLandSearchComponent }
        ] },
        { path: ':orderID', component: OrderComponent, title: 'routes.orderDetails' },
      ] },
      { path: 'management', title: 'routes.management', loadChildren: () => import('./management/management.module').then(m => m.ManagementModule), canActivate: [ClientGuard] },
      { path: 'alerts', title: 'routes.alerts', loadChildren: () => import('./alerts/alerts.module').then(m => m.AlertsModule), data: { breadcrumb: { label: "Alerts", url: "alerts" } }, canActivate: [ClientGuard] },
      { path: 'messages', title: 'routes.messages', loadChildren: () => import('./messages/messages.module').then(m => m.MessagesModule), data: { breadcrumb: { label: "Messages", url: "messages" } }, canActivate: [ClientGuard]  },
      { path: 'accounting', title: 'routes.accounting', loadChildren: () => import('./accounting/accounting.module').then(m => m.AccountingModule), canActivate: [ClientGuard] },
      { path: 'reports', title: 'routes.reporting', loadChildren: () => import('./reporting/reporting.module').then(m => m.ReportsModule), canActivate: [ClientGuard] },
      { path: 'bundles', title: 'routes.bundles', loadChildren: () => import('./bundles/bundles.module').then(m => m.BundlesModule), canActivate: [ClientGuard] },
      { path: 'signout-callback-oidc', component: LoggedOutComponent, title: 'routes.signedOut' },
      { path: 'callback', component: CallbackComponent, canActivate: [ClientGuard] },
      { path: 'my-account', component: MyAccountComponent, title: 'routes.myAccount', canActivate: [ClientGuard] },
      { path: 'information-documents', component: InformationDocumentsComponent, title: 'routes.information', canActivate: [ClientGuard] },
      { path: 'contact-us', component: ContactUsComponent, title: 'routes.contactUs', canActivate: [ClientGuard] },
      { path: 'system-events', component: SystemEventsHistoryComponent, title: 'routes.systemEvents', canActivate: [ClientGuard] },
      { path: 'vinsights', component: VinsightsComponent, title: 'routes.vinsight', canActivate: [ClientGuard] },
      { path: 'hubreports', title: 'routes.hubReports', canActivate: [ClientGuard], children: [
        { path: '', component: HubReportsGridComponent },
        { path: ':envelopeID', component: HubReportComponent }
      ] },
      { path: 'hubreportsv2', title: 'routes.hubReports', canActivate: [ClientGuard], children: [
        { path: '', component: HubReportsV2GridComponent },
        { path: ':hubReportID', component: HubReportV2Component }
      ] },
      // Wildcard route for a 404 page
      { path: '**', component: PageNotFoundComponent, title: 'routes.pageNotFound', data: { breadcrumb: { label: '404', url: "" } } }
    ]
  },
  {
    path: 'print', outlet: 'print', component: PrintComponent, children: [
      { path: 'orders', component: PrintOrderComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, anchorScrolling: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
